import { render, staticRenderFns } from "./UpdatePartnerStatus.vue?vue&type=template&id=b3d52e08"
import script from "./UpdatePartnerStatus.vue?vue&type=script&lang=js"
export * from "./UpdatePartnerStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports